import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import 'dayjs/locale/en-gb';

import './styles/globals.css';
import { Providers } from './providers';
import { router } from './routes';
import { docNgonNgu, khoiTaoI18n } from './i18n';
import { initAuth } from './lib/auth/oidc';

/**
 * i18n phải khởi tạo **trước** khi React vẽ: `useTranslation` đọc instance này
 * lúc mount, và nếu nó chưa có resource thì nhịp đầu tiên hiện nguyên chuỗi khoá.
 */
khoiTaoI18n();

/**
 * Ngày tháng theo ngôn ngữ đang chọn.
 *
 * `en-gb` chứ không `en`: ngày của kho là `dd/MM/yyyy`, mà `en` (US) đảo thành
 * `MM/dd/yyyy` — `03/04` đọc sai tháng là lỗi nghiệp vụ, không phải lỗi trình bày.
 */
dayjs.locale(docNgonNgu() === 'en' ? 'en-gb' : 'vi');

const container = document.getElementById('root');
if (!container) {
  throw new Error('Không tìm thấy phần tử #root trong index.html');
}

// Nạp phiên Keycloak trước khi vẽ, để AuthGate không đẩy nhầm người đã đăng nhập về màn đăng nhập.
void initAuth().finally(() => {
  createRoot(container).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
});
